// NATIVE 
import React, { useEffect, useState } from 'react'


// INSTALLED 
import { Button, Divider } from '@mui/material';


// CUSTOM 
import { mtDividerUpTable } from '../../commons';
import { hasPemissions } from '../../commons/utils';
import { SnackAlert } from '../../components/SnackAlert';
import { TableParametros } from '../../components/tables/TableParametros';
import { BreadCrumbsAndTitle } from '../../components/generics/BreadCrumbsAndTitle';
import { CreateDialogParameter } from '../../components/modals/parametros/CreateDialogParameter';
import { AlertsInformativos } from '../../components/generics/AlertsInformativos';
import { alertInformativo } from '../../commons/texts';



/**
 * The `Parametros` component is responsible for rendering the parameters page.
 * It includes functionality for checking user permissions, opening and closing
 * a modal dialog for creating parameters, and displaying alerts.
 *
 * @component
 *
 * @example
 * return (
 *   <Parametros />
 * )
 *
 * @returns {JSX.Element} The rendered parameters page component.
 *
 * @remarks
 * This component uses several hooks:
 * - `useState` to manage the state of the modal dialog, creation permissions, and alert messages.
 * - `useEffect` to check if the user has permission to create parameters when the component mounts.
 *
 * The component also includes several helper functions:
 * - `canCheckCanCreate` to check if the user has permission to create parameters.
 * - `openModal` to open the modal dialog if the user has the necessary permissions.
 * - `handleCloseDialogCrearParameter` to close the modal dialog.
 * - `validateLsPermissions` to display an alert message if the user does not have the necessary permissions.
 *
 * The component renders:
 * - A `SnackAlert` component to display alert messages.
 * - A `BreadCrumbsAndTitle` component to display the page title and breadcrumbs.
 * - A `Button` to open the modal dialog for creating parameters, if the user has the necessary permissions.
 * - A `Divider` to separate the button from the table.
 * - A `CreateDialogParameter` component to render the modal dialog for creating parameters.
 * - A `TableParametros` component to display the list of parameters.
 */
export const Parametros = () => {


    // USE STATE 
    const [openTurno, setOpenTurno] = useState(false);

    const [canCreate, setCanCreate] = useState(false);


    const [alert_snack, setAlertSnack] = React.useState(false);
    const [msgSnack, setMsgSnack] = React.useState({
        msg: '',
        status: 'success'
    });


    // USE EFFECT 
    useEffect(() => {
      canCheckCanCreate();
    }, []);

    
    
    // CONST FUNCTIONS 
    const canCheckCanCreate = async () => {
         
      const havePermissions = await hasPemissions('modulo.thumano', 'modulo.parametros', 'create');

      setCanCreate(havePermissions);

    }



    const openModal = async() => {

        // modulo.parametros                             nombre modulo     sub modulo    permission
        const havePermissionsCreate = await hasPemissions('modulo.thumano', 'modulo.parametros', 'create');

        if( !havePermissionsCreate ){
  
          await validateLsPermissions('No tienes pemisos para (Crear) parametros.');

          return false; 

        }
         
         setOpenTurno(true)
    }
  
    const handleCloseDialogCrearParameter = () => {
          setOpenTurno(false)
    }


    

   const validateLsPermissions = async(message:string) => {

    const errors:any = {
      msg: message,
      status: 'error'
    };
  
    await setMsgSnack(errors);
    await setAlertSnack(true);
  
  
  }


  return (


    <>
      
      <SnackAlert open={alert_snack} onclick={setAlertSnack} text={msgSnack.msg} severity={msgSnack.status}/>

        <BreadCrumbsAndTitle
                title="Listado Parametros" 
                mainModule="Talento Humano" 
                parent="Listado Parametros"
                action="" />

        <div style={{ display: 'flex', justifyContent: 'end'}}>
          {
             canCreate && <Button   variant='contained' sx={{ marginBottom: 3 }} onClick={openModal}>Crear Parametro</Button>
          }
        </div>

        <AlertsInformativos type={'info'} title={'info'} content={alertInformativo.parametros} />
        <Divider sx={{ marginBottom: mtDividerUpTable }}/>

         <CreateDialogParameter open={openTurno} handleCloseDialogCrearParameter={handleCloseDialogCrearParameter} />
         <TableParametros /> 

    </>

  )
}
